var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaceMeh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.96 17.56a1.877 1.877 0 013.75 0 1.877 1.877 0 01-1.874 1.875 1.873 1.873 0 01-1.875-1.875zm9.376 0c0-1.037.838-1.875 1.875-1.875 1.031 0 1.875.838 1.875 1.875a1.877 1.877 0 01-1.875 1.875 1.873 1.873 0 01-1.875-1.875z",
    fill: "#777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.5 20.373c0-8.286 6.715-15 15-15s15 6.714 15 15c0 8.285-6.715 15-15 15s-15-6.715-15-15zm10.336-.938a1.877 1.877 0 001.875-1.875 1.877 1.877 0 00-1.875-1.875 1.873 1.873 0 00-1.875 1.875c0 1.037.838 1.875 1.875 1.875zm9.375-3.75a1.873 1.873 0 00-1.875 1.875c0 1.037.838 1.875 1.875 1.875a1.877 1.877 0 001.875-1.875 1.877 1.877 0 00-1.875-1.875zM14.875 25.06a.94.94 0 00-.938.938.94.94 0 00.938.937h11.25a.94.94 0 00.938-.937.94.94 0 00-.938-.938h-11.25z",
    fill: "#777"
  })));
}

export default SvgFaceMeh;